export default __webpack_public_path__ + "static/media/38.b9cafe79.jpeg";